"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDigestHighlightsGroupDto = instanceOfDigestHighlightsGroupDto;
exports.DigestHighlightsGroupDtoFromJSON = DigestHighlightsGroupDtoFromJSON;
exports.DigestHighlightsGroupDtoFromJSONTyped = DigestHighlightsGroupDtoFromJSONTyped;
exports.DigestHighlightsGroupDtoToJSON = DigestHighlightsGroupDtoToJSON;
exports.DigestHighlightsGroupDtoToJSONTyped = DigestHighlightsGroupDtoToJSONTyped;
var DigestHighlightDto_1 = require("./DigestHighlightDto");
/**
 * Check if a given object implements the DigestHighlightsGroupDto interface.
 */
function instanceOfDigestHighlightsGroupDto(value) {
    if (!('serp' in value) || value['serp'] === undefined)
        return false;
    if (!('youtube' in value) || value['youtube'] === undefined)
        return false;
    return true;
}
function DigestHighlightsGroupDtoFromJSON(json) {
    return DigestHighlightsGroupDtoFromJSONTyped(json, false);
}
function DigestHighlightsGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'serp': (json['serp'].map(DigestHighlightDto_1.DigestHighlightDtoFromJSON)),
        'youtube': (json['youtube'].map(DigestHighlightDto_1.DigestHighlightDtoFromJSON)),
    };
}
function DigestHighlightsGroupDtoToJSON(json) {
    return DigestHighlightsGroupDtoToJSONTyped(json, false);
}
function DigestHighlightsGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'serp': (value['serp'].map(DigestHighlightDto_1.DigestHighlightDtoToJSON)),
        'youtube': (value['youtube'].map(DigestHighlightDto_1.DigestHighlightDtoToJSON)),
    };
}
